<template>
  <div>
    <main-layout>
      <v-tabs v-model="tabs" color="white" :slider-color="$store.state.theme.brand_color">
        <v-tab ripple :key="'EmployeeList'" :href="'#EmployeeList'">Employee List</v-tab>
        <v-tab ripple :key="'AutoAnnouncement'" :href="'#AutoAnnouncement'"
          >Auto Announcement</v-tab
        >
        <v-tab ripple :key="'SopManagement'" :href="'#SopManagement'">SOP Management</v-tab>
        <v-tab ripple :key="'SopReport'" :href="'#SopReport'">SOP Report</v-tab>
      </v-tabs>
      <div v-if="tabs === 'EmployeeList'">
        <EmployeeList
          :statusMasterData="statusMasterData"
          :divisionMasterData="divisionMasterData"
          :departmentMasterData="departmentMasterData"
          :affiliationMasterData="affiliationMasterData"
          :positionMasterData="positionMasterData"
        ></EmployeeList>
      </div>
      <div v-else-if="tabs === 'AutoAnnouncement'">
        <AutoAnnouncement
          :divisionMasterData="divisionMasterData"
          :departmentMasterData="departmentMasterData"
          :affiliationMasterData="affiliationMasterData"
        ></AutoAnnouncement>
      </div>
      <div v-else-if="tabs === 'SopManagement'">
        <SopManagement></SopManagement>
      </div>
      <div v-else-if="tabs === 'SopReport'">
        <SopReport></SopReport>
      </div>
    </main-layout>
  </div>
</template>

<script>
import hopinnHrApi from '@/api/hopinn-hr'
import EmployeeList from './EmployeeList.vue'
import AutoAnnouncement from './AutoAnnouncement.vue'
import SopManagement from './SopManagement.vue'
import SopReport from './SopReport.vue'

export default {
  components: {
    EmployeeList,
    AutoAnnouncement,
    SopManagement,
    SopReport
  },
  data() {
    return {
      tabs: 'EmployeeList',
      statusMasterData: [],
      divisionMasterData: [],
      departmentMasterData: [],
      affiliationMasterData: [],
      positionMasterData: []
    }
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      vm.tabs = vm.$route.query.tab
    } else {
      vm.tabs = 'EmployeeList'
    }
  },
  async mounted() {
    this.$store.dispatch('loading')
    await this.$store.dispatch('loadCategory')
    await this.$store.dispatch('loadProducts')
    await this.$store.dispatch('loadSetting')
    await this.getMasterData()
  },
  methods: {
    async getMasterData() {
      return new Promise(async (resolve) => {
        var allGet = [
          this.getStatus(),
          this.getDivision(),
          this.getDepartment(),
          this.getAffiliation(),
          this.getPosition()
        ]
        await Promise.all(allGet)
        this.$store.commit('CLEAR_LOADING')
        resolve()
      })
    },
    async getStatus() {
      const vm = this
      try {
        const response = await hopinnHrApi.getStatus()
        if (response && response.data.responsecode == 200) {
          vm.statusMasterData = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getAffiliation() {
      const vm = this
      try {
        const response = await hopinnHrApi.getAffiliation()
        if (response && response.data.responsecode == 200) {
          vm.affiliationMasterData = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getDepartment() {
      const vm = this
      try {
        const response = await hopinnHrApi.getDepartment()
        if (response && response.data.responsecode == 200) {
          vm.departmentMasterData = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getDivision() {
      const vm = this
      try {
        const response = await hopinnHrApi.getDivision()
        if (response && response.data.responsecode == 200) {
          vm.divisionMasterData = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getPosition() {
      const vm = this
      try {
        const response = await hopinnHrApi.getPosition()
        if (response && response.data.responsecode == 200) {
          vm.positionMasterData = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    }
  },
  watch: {
    tabs: function () {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/HumanResource.vue